const DETAIL_ROW_HEIGHT = 36;
const DETAIL_HEADER_HEIGHT = 40;
const DETAIL_PANEL_PADDING = 16;
const DETAIL_TOOLBAR_HEIGHT = 120;
const DETAIL_GRID_SCROLLBAR = 17;

/** 세부 그리드·마스터 detail 행 높이 (건수 기준, 전 행 노출) */
export function getSamBasic02DetailHeights(detailCount) {
  const n = Math.max(0, Number(detailCount) || 0);
  const rowCount = Math.max(1, n);
  const gridHeight =
    DETAIL_HEADER_HEIGHT +
    rowCount * DETAIL_ROW_HEIGHT +
    DETAIL_GRID_SCROLLBAR;
  const panelHeight = Math.max(
    200,
    DETAIL_PANEL_PADDING + DETAIL_TOOLBAR_HEIGHT + gridHeight
  );
  return { gridHeight, panelHeight };
}

export function applyExpandedDetailRowHeight(masterApi, pmCd, detailCount) {
  if (!masterApi || !pmCd) return;
  const panelHeight = getSamBasic02DetailHeights(detailCount).panelHeight;
  masterApi.forEachNode((node) => {
    if (!node.detail) return;
    const rPm = String(
      node.data?.pmCd ?? node.data?.PmCd ?? node.data?.PM_CD ?? ''
    ).trim();
    if (rPm === pmCd) {
      node.setRowHeight(panelHeight);
    }
  });
  masterApi.onRowHeightChanged?.();
  masterApi.resetRowHeights?.();
}

export const SAM_BASIC_02_DETAIL_GRID = {
  rowHeight: DETAIL_ROW_HEIGHT,
  headerHeight: DETAIL_HEADER_HEIGHT,
};
